// Module
var code = " <header></header> <div id=\"wrapper\"> <div id=\"sidebar-wrapper\" class=\"col-md-1\"> <div id=\"sidebar\"> <menu></menu> </div> </div> <div id=\"main-wrapper\" class=\"col-md-11 pull-right\"> <div id=\"main\"> <div ui-view> </div> </div> <div class=\"col-md-12 footer\"> <footer> </footer> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'layout/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;